import { getApiBaseUrl } from '../utils/api';
import { getTrackingDataForSubmission } from '../utils/trackingParams';

/**
 * Track WhatsApp button click and get WhatsApp URL with reference
 */
export const trackWhatsAppClick = async () => {
  const API_URL = getApiBaseUrl();
  const tracking = getTrackingDataForSubmission();

  try {
    const response = await fetch(`${API_URL}/api/wa-ref`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(tracking)
    });

    if (response.ok) {
      const data = await response.json();
      
      // Fire gtag event
      if (window.gtag) {
        window.gtag('event', 'whatsapp_click', {
          'event_category': 'engagement',
          'event_label': tracking.page_url || 'unknown',
          'ref_code': data.ref
        });
      }
      
      return data.whatsapp_url;
    }
  } catch (error) {
    console.error('WhatsApp tracking error:', error);
  }
  
  // Fallback URL without ref
  return 'https://wa.me/919205891804?text=Hi%20Acad%20Studio%2C%20I%27d%20like%20to%20know%20more%20about%20your%20services.';
};

/**
 * Track phone number click
 */
export const trackPhoneClick = async (phoneNumber) => {
  const API_URL = getApiBaseUrl();
  const tracking = getTrackingDataForSubmission();

  try {
    await fetch(`${API_URL}/api/log-call-click`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...tracking,
        phone_number: phoneNumber
      })
    });

    // Fire gtag event
    if (window.gtag) {
      window.gtag('event', 'phone_click', {
        'event_category': 'engagement',
        'event_label': tracking.page_url || 'unknown'
      });
    }
  } catch (error) {
    console.error('Phone click tracking error:', error);
  }
};

/**
 * Enhance tel: links with click tracking
 */
export const setupPhoneTracking = () => {
  // Find all tel: links and add click handler
  document.querySelectorAll('a[href^="tel:"]').forEach(link => {
    if (!link.dataset.trackingAdded) {
      link.dataset.trackingAdded = 'true';
      link.addEventListener('click', (e) => {
        const phoneNumber = link.href.replace('tel:', '');
        trackPhoneClick(phoneNumber);
        // Don't prevent default - let the call happen
      });
    }
  });
};
